export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/abstract_pattern.f2873b0.svg";